import React, { useEffect, useRef, useState } from 'react';
import 'photoswipe/dist/photoswipe.css';
import { Gallery, Item } from 'react-photoswipe-gallery';

function LazyImageItem({ imageData }) {
  const [isVisible, setIsVisible] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(false);
  const observerRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (observerRef.current) observer.observe(observerRef.current);
    return () => observer.disconnect();
  }, []);

  const { id, image, fullImage, width, height, title, description, alt } = imageData;

  // ✅ OPTIONAL: Preload full image on hover
  const preloadFullImage = () => {
    const img = new Image();
    img.src = fullImage;
  };

  return (
    <div className="col-lg-6 col-md-6 my-3 portfolio-item filter-app" key={id} ref={observerRef}>
      {isVisible && (
        <div className="portfolio-wrap">
          <Item
            original={fullImage}
            thumbnail={image}
            width={width}
            height={height}
            title={title}
          >
            {({ ref: imgRef, open }) => (
              <>
                <img
                  ref={imgRef}
                  onClick={open}
                  onMouseEnter={preloadFullImage} // ✅ Optional preload
                  src={image}
                  alt={alt}
                  loading="lazy"
                  onLoad={() => setImgLoaded(true)}
                  style={{
                    cursor: 'pointer',
                    width: '100%',
                    opacity: imgLoaded ? 1 : 0,
                    transition: 'opacity 0.5s ease-in-out'
                  }}
                />
                <div className="portfolio-info">
                  {title && <h4>{title}</h4>}
                  {description && <p>{description}</p>}
                  <div className="portfolio-links">
                    <button
                      type="button"
                      onClick={open}
                      className="btn btn-link p-0"
                      title={title}
                    >
                      <i className="bi bi-plus"></i>
                    </button>
                  </div>
                </div>
              </>
            )}
          </Item>
        </div>
      )}
    </div>
  );
}

function Items({ data }) {
  return (
    <div className="row">
      <Gallery
        options={{
          escKey: true,
          clickToClose: false,
          closeOnVerticalDrag: false,
          closeOnScroll: false,
          zoom: false,
          wheelToZoom: false,
          allowMouseWheel: true,
          bgOpacity: 0.9,
          uiElements: [
            { name: 'close', order: 1 },
            { name: 'fullscreen', order: 2 }
          ]
        }}
      >
        {data.map((item) => (
          <LazyImageItem key={item.id} imageData={item} />
        ))}
      </Gallery>
    </div>
  );
}

export default Items;
